import { AutoColumn, ColumnCenter } from 'components/Column'
import IntroCard from 'components/IntroCard'
import { RowBetween, RowFixed } from 'components/Row'
import { TransactionResponse } from '@ethersproject/providers'

import {
  CustomAppBody,
  DynamicSection,
  MobileStepperWrapper,
  RowContainer,
  ScrollablePage,
  Step,
  StepContent,
  StepDescription,
  StepLine,
  StepNumber,
  StepperContainer,
  StepperHeader,
  StepperWrapper,
  StepReview,
  StepTitle,
  StyledInput,
  Wrapper,
} from 'pages/AddLiquidity/styled'
import React, { useContext, useEffect } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { ExternalLink, TYPE } from 'theme'
import InputTextPanel, { ContainerRow, InputContainer, InputPanel } from './InputTextPanel'
import { StyledTabButton } from 'pages/FarmPool'
import { useDerivedMintInfo, useMintActionHandlers, useMintState } from 'state/mint/hooks'
import { ETHER, Token, TokenAmount, WETH9 } from '@uniswap/sdk-core'
import { Field } from 'state/mint/actions'
import { Text } from 'rebass'

import { maxAmountSpend } from 'utils/maxAmountSpend'
import CurrencyInputPanel from 'components/CurrencyInputPanel'
import { ButtonError, ButtonGray, ButtonLight, ButtonPrimary } from 'components/Button'
import { FeeAmount, nearestUsableTick, NonfungiblePositionManager, TickMath } from '@uniswap/v3-sdk'
import { useTransactionAdder } from 'state/transactions/hooks'
import { useWalletModalToggle } from 'state/application/hooks'
import { calculateGasMargin, calculateSlippageAmount, getContract, getEtherscanLink } from 'utils'
import { CURRENT_CHAIN, LAUNCHER_ADDRESS, V2_FACTORY_ADDRESS, V2_ROUTER_ADDRESS } from '@hyperswap/addresses'
import { abi as Launcher_ABI } from '../../abis/hyperswap_launcher.json'
import { formatUnits, parseUnits } from 'ethers/lib/utils'
import { useToken } from 'hooks/Tokens'
import { PairState } from 'hooks/useV2Pairs'
import { useAddUserToken, usePairAdder, useUserSlippageTolerance } from 'state/user/hooks'
import Modal from 'components/Modal'
import { useActiveWeb3React } from 'hooks'
import { Helmet } from 'react-helmet'
import { CheckCircle, Plus } from 'react-feather'
import { Dots } from 'pages/Pool/styleds'
import { v4 as uuidv4 } from 'uuid'
import { generateSignature } from 'utils/cryptoUtils'
import { API_GASLESS_BASE_URL } from 'constants/links'
import { useContract, useV2RouterContract, useV3Factory, useV3NFTPositionManagerContract } from 'hooks/useContract'
import axios from 'axios'
import FeeSelector from 'components/FeeSelector'
import useTransactionDeadline from 'hooks/useTransactionDeadline'
import { ZERO_PERCENT } from '../../constants'
import { BigNumber } from 'ethers'
import { wrappedCurrency } from 'utils/wrappedCurrency'
import { useV3PositionFromTokenId } from 'hooks/useV3Positions'
import { useDerivedPositionInfo } from 'hooks/useDerivedPositionInfo'
import { useV3DerivedMintInfo, useV3MintActionHandlers, useV3MintState } from 'state/mint/v3/hooks'
import { NONFUNGIBLE_POSITION_MANAGER_ADDRESSES } from 'constants/v3'
import { Bound } from 'state/mint/v3/actions'
import { useUSDCValue } from 'hooks/useUSDCPrice'
import { ApprovalState, useApproveCallback } from 'hooks/useApproveCallback'
import { abi as IUniswapV2FactoryABI } from '@uniswap/v2-core/build/IUniswapV2Factory.json'
import { OutlineCard } from 'components/Card'
import { useETHBalances } from 'state/wallet/hooks'
import { isLauncherSubdomain } from 'utils/data'
import { useHistory } from 'react-router-dom'
import useAddTokenToMetamask from 'hooks/useAddTokenToMetamask'

const Tabs = styled.div`
  ${({ theme }) => theme.flexRowNoWrap}
  align-items: center;
  border-radius: 3rem;
  justify-content: space-evenly;
`

const InputContainerStyled = styled.div`
  display: flex;
  flex-direction: row;
  gap: 6px;

  input {
    all: unset;
    color: #4afc38;
    font-size: 16px;
    width: 36px;
    text-align: center;
    height: 36px;
    border: 1px solid lightgrey;
    border-radius: 8px;
  }
`
const InputValueStyled = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  color: lightgrey;
`

const ButtonStyled = styled.button`
  all: unset;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 300ms;
  border-radius: 0.5rem;
  padding: 8px;

  &:hover {
    background-color: #565a691a;
  }
`
const Aligner = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`

const Launcher = () => {
  const { independentField, typedValue } = useMintState()
  const { account, library, chainId } = useActiveWeb3React()
  const [allowedSlippage] = useUserSlippageTolerance() // custom from users
  const factoryContract = useContract(V2_FACTORY_ADDRESS, IUniswapV2FactoryABI)
  const factoryV3Contract = useV3Factory()
  const launcherBalance = useETHBalances([LAUNCHER_ADDRESS])
  const launcherBalanceFormatted = launcherBalance?.[LAUNCHER_ADDRESS]
    ? launcherBalance?.[LAUNCHER_ADDRESS]?.toSignificant(2)
    : '0'

  const history = useHistory()
  const toggleWalletModal = useWalletModalToggle()
  const theme = useContext(ThemeContext)
  const deadline = useTransactionDeadline()
  const [name, setName] = React.useState('')
  const [symbol, setSymbol] = React.useState('')
  const [supply, setSupply] = React.useState('1000')
  const [decimals, setDecimals] = React.useState<number>(18)
  const [isV2LP, setIsV2LP] = React.useState(false)
  const [loading, setLoading] = React.useState(false)
  const [feeAmount, setFeeAmount] = React.useState<FeeAmount | undefined>(undefined)
  const positionManager = useV3NFTPositionManagerContract()

  const [tokenAddress, setTokenAddress] = React.useState<null | string>('')
  const [addTokenFlag, setAddTokenFlag] = React.useState<boolean>(false)

  const searchToken = useToken(tokenAddress || '')
  const [modalIsOpen, setModalIsOpen] = React.useState(false)
  const addPair = usePairAdder()
  const addToken = useAddUserToken()

  const [loadingCreateLP, setLoadingCreateLP] = React.useState<boolean>(false)
  const [successCreateLP, setSuccessCreateLP] = React.useState<boolean>(false)
  const [errorCreate, setErrorCreate] = React.useState<string>('')

  const [loadingAddLP, setLoadingAddLP] = React.useState<boolean>(false)

  const [tokenLaunched, setTokenLaunched] = React.useState<boolean>(false)
  const router = useV2RouterContract()
  const currencyA = ETHER

  const { addToken: addTokenToWallet, success: successAddTokenToMetamask } = useAddTokenToMetamask(searchToken as any)

  React.useEffect(() => {
    if (!isLauncherSubdomain()) {
      history.push('/swap')
    }
  }, [history])

  // LP V2
  const {
    dependentField,
    currencies,
    pair,
    pairState,
    currencyBalances,
    parsedAmounts,
    noLiquidity,
    error,
  } = useDerivedMintInfo(ETHER ?? undefined, searchToken ?? undefined)

  // check whether the user has approved the router on the tokens
  const [approvalA, approveACallback] = useApproveCallback(parsedAmounts[Field.CURRENCY_A], V2_ROUTER_ADDRESS)
  const [approvalB, approveBCallback] = useApproveCallback(parsedAmounts[Field.CURRENCY_B], V2_ROUTER_ADDRESS)

  // LP V3
  // check for existing position if tokenId in url
  const { position: existingPositionDetails } = useV3PositionFromTokenId(undefined)
  const { position: existingPosition } = useDerivedPositionInfo(existingPositionDetails)

  const {
    ticks,
    dependentField: dependentFieldV3,
    parsedAmounts: parsedAmountsV3,
    position,
    currencies: currenciesV3,
    errorMessage,
    invalidPool,
    invalidRange,
    depositADisabled,
    depositBDisabled,
  } = useV3DerivedMintInfo(
    currencyA ?? undefined,
    searchToken ?? undefined,
    feeAmount,
    currencyA ?? undefined,
    existingPosition
  )

  const { independentField: independentFieldV3, typedValue: typedValueV3, startPriceTypedValue } = useV3MintState()
  const formattedAmountsV3 = {
    [independentFieldV3]: typedValueV3,
    [dependentFieldV3]: parsedAmountsV3[dependentFieldV3]?.toSignificant(6) ?? '',
  }

  const { [Bound.LOWER]: tickLower, [Bound.UPPER]: tickUpper } = ticks

  const {
    onFieldAInput: onFieldAInputV3,
    onFieldBInput: onFieldBInputV3,
    onLeftRangeInput,
    onRightRangeInput,
    onStartPriceInput,
  } = useV3MintActionHandlers(noLiquidity)

  const usdcValues = {
    [Field.CURRENCY_A]: useUSDCValue(parsedAmountsV3[Field.CURRENCY_A]),
    [Field.CURRENCY_B]: useUSDCValue(parsedAmountsV3[Field.CURRENCY_B]),
  }

  // check whether the user has approved the router on the tokens
  const [approvalAV3, approveACallbackV3] = useApproveCallback(
    parsedAmountsV3[Field.CURRENCY_A],
    chainId ? NONFUNGIBLE_POSITION_MANAGER_ADDRESSES[CURRENT_CHAIN] : undefined
  )
  const [approvalBV3, approveBCallbackV3] = useApproveCallback(
    parsedAmountsV3[Field.CURRENCY_B],
    chainId ? NONFUNGIBLE_POSITION_MANAGER_ADDRESSES[CURRENT_CHAIN] : undefined
  )

  // we need an existence check on parsed amounts for single-asset deposits
  const showApprovalAV3 = approvalAV3 !== ApprovalState.APPROVED && !!parsedAmountsV3[Field.CURRENCY_A]
  const showApprovalBV3 = approvalBV3 !== ApprovalState.APPROVED && !!parsedAmountsV3[Field.CURRENCY_B]

  const isValid = !errorMessage && !invalidRange

  React.useEffect(() => {
    const handleInfiniteRange = () => {
      if (!currencyA || !searchToken || !feeAmount) return

      const MAX_THRESHOLD = BigNumber.from('10').pow(36)

      const tickSpacing =
        feeAmount === 10000 ? 200 : feeAmount === 3000 ? 60 : feeAmount === 500 ? 10 : feeAmount === 100 ? 1 : 1 // Default to 1 if feeAmount is undefined (failsafe)

      // Get the nearest usable ticks for min and max based   on tickSpacing
      const minTick = nearestUsableTick(TickMath.MIN_TICK, tickSpacing)
      const maxTick = nearestUsableTick(TickMath.MAX_TICK, tickSpacing)

      const sqrtRatioX96Min = TickMath.getSqrtRatioAtTick(minTick)
      const sqrtRatioX96Max = TickMath.getSqrtRatioAtTick(maxTick)

      const sqrtRatioX96MinBN = BigNumber.from(sqrtRatioX96Min.toString())
      const sqrtRatioX96MaxBN = BigNumber.from(sqrtRatioX96Max.toString())

      const currencyASorted = currencyA
      const currencyBSorted = searchToken

      // Determine the number of decimals for the tokens (default to 18 decimals like ETH)
      const minDecimals = Math.min(currencyASorted?.decimals ?? 18, currencyBSorted?.decimals ?? 18)
      const maxDecimals = Math.max(currencyASorted?.decimals ?? 18, currencyBSorted?.decimals ?? 18)

      const minPrice = sqrtRatioX96MinBN.mul(sqrtRatioX96MinBN).div(BigNumber.from(2).pow(192))
      const maxPrice = sqrtRatioX96MaxBN.mul(sqrtRatioX96MaxBN).div(BigNumber.from(2).pow(192))

      const safeMinPrice = minPrice.isZero()
        ? formatUnits(BigNumber.from(1), minDecimals) // If zero, set a minimal valid value based on token decimals
        : formatUnits(minPrice, minDecimals) // Otherwise, format the price properly

      const safeMaxPrice = maxPrice.gte(BigNumber.from('10').pow(18)) // Check if maxPrice is greater than 10^18
        ? formatUnits(MAX_THRESHOLD, maxDecimals) // If so, cap it at MAX_THRESHOLD (10^36)
        : formatUnits(maxPrice.mul(BigNumber.from(999)).div(BigNumber.from(1000)), maxDecimals) // Otherwise, apply 99.9% adjustment

      onLeftRangeInput(safeMinPrice)
      onRightRangeInput(safeMaxPrice)
    }

    if (currencyA && searchToken) {
      handleInfiniteRange()
      console.log('infinite range')
    }
  }, [currencyA, decimals, feeAmount, onLeftRangeInput, onRightRangeInput, searchToken])

  React.useEffect(() => {
    if (tokenAddress && searchToken && searchToken instanceof Token && addTokenFlag) {
      addToken(searchToken as Token)

      if (pairState === PairState.EXISTS && pair) {
        addPair(pair)
      }

      setAddTokenFlag(false)
    }
  }, [searchToken, addTokenFlag, pair, pairState, tokenAddress, addToken, addPair])

  // get formatted amounts
  const formattedAmounts = {
    [independentField]: typedValue,
    [dependentField]: parsedAmounts[dependentField]?.toSignificant(6) ?? '',
  }

  const { onFieldAInput, onFieldBInput } = useMintActionHandlers(noLiquidity)

  const maxAmounts: { [field in Field]?: TokenAmount } = [Field.CURRENCY_A, Field.CURRENCY_B].reduce(
    (accumulator, field) => {
      return {
        ...accumulator,
        [field]: maxAmountSpend(currencyBalances[field]),
      }
    },
    {}
  )

  const atMaxAmounts: { [field in Field]?: TokenAmount } = [Field.CURRENCY_A, Field.CURRENCY_B].reduce(
    (accumulator, field) => {
      return {
        ...accumulator,
        [field]: maxAmounts[field]?.equalTo(parsedAmounts[field] ?? '0'),
      }
    },
    {}
  )

  const handleChangeName = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    const alphanumericRegex = /^[a-zA-Z0-9]*$/

    if (value.length <= 10 && alphanumericRegex.test(value)) {
      setName(value)
    }
  }

  const handleChangeSymbol = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    const alphanumericRegex = /^[a-zA-Z0-9]*$/

    if (value.length <= 10 && alphanumericRegex.test(value)) {
      setSymbol(value)
    }
  }
  const handleChangeSupply = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value

    // Remove any non-numeric characters
    let numericValue = value.replace(/[^0-9]/g, '')

    // Remove leading zeros
    if (numericValue.length > 0) {
      numericValue = numericValue.replace(/^0+/, '')
    }

    // Limit the length to 15 digits
    if (numericValue.length > 15) {
      numericValue = numericValue.substring(0, 15)
    }

    setSupply(numericValue)
  }

  const incrementDecimals = () => {
    if (decimals !== 18) {
      setDecimals(decimals + 1)
    }
  }

  const decrementDecimals = () => {
    if (decimals !== 6) {
      setDecimals(decimals - 1)
    }
  }

  const handleDecimals = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputDecimals = parseInt(e.target.value.replace(/^0+/, ''), 10)

    if (isNaN(inputDecimals) || inputDecimals < 0) {
      setDecimals(8)
      return
    }

    if (inputDecimals > 18) {
      setDecimals(18)
      return
    }
    if (inputDecimals < 6) {
      setDecimals(6)
      return
    }
    setDecimals(inputDecimals)
  }

  const addTransaction = useTransactionAdder()

  async function onCreate() {
    const CREATE_PRICE = '0.1'
    if (!chainId || !library || !account) return
    const launcher = getContract(LAUNCHER_ADDRESS, Launcher_ABI, library, account)

    const estimate = launcher.estimateGas.createToken
    const method = launcher.createToken
    setTokenAddress(null)
    const args = [name, symbol, decimals, parseUnits(supply, decimals).toString(), account]

    setLoading(true)

    await estimate(...args, { value: parseUnits(CREATE_PRICE, 18) })
      .then((estimatedGasLimit) =>
        method(...args, {
          gasLimit: calculateGasMargin(estimatedGasLimit),
          value: parseUnits(CREATE_PRICE, 18),
        }).then(async (response: any) => {
          addTransaction(response, {
            summary: `Create token $${symbol}`,
          })

          const receipt = await response.wait()
          const transaction = await library.getTransaction(receipt.transactionHash)

          if (transaction.from.toLowerCase() === account.toLowerCase()) {
            const event = receipt.events?.find((event: any) => event.event === 'TokenCreated')

            if (event) {
              const tokenAddress = event.args._address
              setTokenAddress(tokenAddress)
              setAddTokenFlag(true)

              setName('')
              setSymbol('')
              setSupply('1000')

              if (tokenAddress) {
                setModalIsOpen(true)
              }
            }
          } else {
            console.warn('Transaction initiator does not match the current account')
          }

          setLoading(false)
        })
      )
      .catch((error) => {
        setLoading(false)
        setTokenAddress(null)
        if (error?.code !== 4001) {
          console.error(error)
        }
      })
  }

  async function onCreateLP() {
    if (!chainId || !library || !account || !router || !factoryContract || !factoryV3Contract) return
    const currencyAAddress = currencyA instanceof Token ? currencyA.address : WETH9[CURRENT_CHAIN].address
    const currencyBAddress = searchToken instanceof Token ? searchToken.address : WETH9[CURRENT_CHAIN].address

    const currencyASymbol = currencyA?.symbol
    const currencyBSymbol = searchToken?.symbol

    const timestamp = Math.floor(Date.now() / 1000)
    const message = `Please sign this message to create pair ${currencyASymbol}-${currencyBSymbol}. Timestamp: ${timestamp}`

    try {
      const signer = library.getSigner()
      const signature = await signer.signMessage(message)
      setErrorCreate('')
      setSuccessCreateLP(false)
      const uuid = uuidv4()
      const body = JSON.stringify({
        taskId: uuid,
        address: account,
        signature: signature,
        message: message,
        tokenA: currencyAAddress,
        tokenB: currencyBAddress,
        version: isV2LP ? 'v2' : 'v3',
        ...(isV2LP ? {} : { fee: `${feeAmount}` }),
      })
      console.log('Create LP payload', body)

      const config = {
        method: 'post',
        url: `${API_GASLESS_BASE_URL}/api/relay-create-pair`,
        headers: {
          'x-signature': generateSignature(message),
          'Content-Type': 'application/json',
        },
        data: body,
      }

      const checkStatus = async () => {
        if (isV2LP) {
          factoryContract.on('PairCreated', (token0, token1, pairAddress) => {
            if (
              (token0.toLowerCase() === currencyAAddress.toLowerCase() &&
                token1.toLowerCase() === currencyBAddress.toLowerCase()) ||
              (token0.toLowerCase() === currencyBAddress.toLowerCase() &&
                token1.toLowerCase() === currencyAAddress.toLowerCase())
            ) {
              console.log(`LP address: ${pairAddress}`)
              factoryContract.removeAllListeners('PairCreated')
              setLoadingCreateLP(false)
              setSuccessCreateLP(true)
              setErrorCreate('')
              setActiveStep(2)
            }
          })
        } else {
          factoryV3Contract.on('PoolCreated', (token0, token1, fee, poolAddress) => {
            if (
              ((token0.toLowerCase() === currencyAAddress.toLowerCase() &&
                token1.toLowerCase() === currencyBAddress.toLowerCase()) ||
                (token0.toLowerCase() === currencyBAddress.toLowerCase() &&
                  token1.toLowerCase() === currencyAAddress.toLowerCase())) &&
              fee === feeAmount
            ) {
              console.log(`LP address: ${poolAddress}`)
              factoryV3Contract.removeAllListeners('PoolCreated')
              setLoadingCreateLP(false)
              setSuccessCreateLP(true)
              setErrorCreate('')
              setActiveStep(2)
            }
          })
        }
      }

      axios
        .request(config)
        .then(async (response) => {
          if (response.data.success === true) {
            setLoadingCreateLP(true)

            await checkStatus()
          } else {
            console.log(response)
            setLoadingCreateLP(false)
            setSuccessCreateLP(false)
            setErrorCreate('An error has occurred. Please try again.')
          }
        })
        .catch((error: any) => {
          console.error(error)
          setLoadingCreateLP(false)
          setSuccessCreateLP(false)
          setErrorCreate('An error has occurred. Please try again.')
        })
    } catch (error) {
      console.error('Error sending transaction:', error)
    }
  }

  async function addLPV2() {
    if (!chainId || !library || !account || !router) return

    const { [Field.CURRENCY_A]: parsedAmountA, [Field.CURRENCY_B]: parsedAmountB } = parsedAmounts
    if (!parsedAmountA || !parsedAmountB || !currencyA || !searchToken || !deadline) {
      return
    }

    const amountsMin = {
      [Field.CURRENCY_A]: calculateSlippageAmount(parsedAmountA, noLiquidity ? ZERO_PERCENT : allowedSlippage)[0],
      [Field.CURRENCY_B]: calculateSlippageAmount(parsedAmountB, noLiquidity ? ZERO_PERCENT : allowedSlippage)[0],
    }

    const usedRouter = router

    const tokenBIsETH = searchToken === ETHER
    const estimate = usedRouter.estimateGas.addLiquidityETH
    const method = usedRouter.addLiquidityETH
    const tokenMin = amountsMin[tokenBIsETH ? Field.CURRENCY_A : Field.CURRENCY_B].toString()
    const tokenMinDecreased = BigNumber.from(tokenMin).mul(90).div(100).toString()

    const args = [
      wrappedCurrency(tokenBIsETH ? currencyA : searchToken, chainId)?.address ?? '', // token
      (tokenBIsETH ? parsedAmountA : parsedAmountB).raw.toString(), // token desired
      tokenMinDecreased, // token min
      amountsMin[tokenBIsETH ? Field.CURRENCY_B : Field.CURRENCY_A].toString(), // eth min
      account,
      deadline.toHexString(),
    ]
    const value = BigNumber.from((tokenBIsETH ? parsedAmountB : parsedAmountA).raw.toString())

    console.log('AddLPV2 Args', args)
    console.log('AddLPV2 value', value.toString())
    setLoadingAddLP(true)

    await estimate(...args, value ? { value } : {})
      .then((estimatedGasLimit) =>
        method(...args, {
          ...(value ? { value } : {}),
          gasLimit: calculateGasMargin(estimatedGasLimit),
        }).then(async (response: TransactionResponse) => {
          addTransaction(response, {
            summary:
              'Add ' +
              parsedAmounts[Field.CURRENCY_A]?.toSignificant(3) +
              ' ' +
              currencies[Field.CURRENCY_A]?.symbol +
              ' and ' +
              parsedAmounts[Field.CURRENCY_B]?.toSignificant(3) +
              ' ' +
              currencies[Field.CURRENCY_B]?.symbol,
          })

          await response.wait()

          setTokenLaunched(true)
          setLoadingAddLP(false)
          if (pairState === PairState.EXISTS && pair) {
            addPair(pair)
          }
        })
      )
      .catch((error) => {
        setTokenLaunched(false)
        setLoadingAddLP(false)
        if (error?.code !== 4001) {
          console.error(error)
        }
      })
      .finally(() => {
        setLoadingAddLP(false)
      })
  }

  async function addLPV3() {
    if (!chainId || !library || !account) return

    if (!positionManager || !currencyA || !searchToken) {
      return
    }

    if (position && account && deadline) {
      const { calldata, value } = NonfungiblePositionManager.addCallParameters(position, {
        slippageTolerance: allowedSlippage,
        recipient: account,
        deadline: deadline.toString(),
        useEther: currencyA === ETHER || searchToken === ETHER,
        createPool: noLiquidity,
      })

      const txn = {
        to: NONFUNGIBLE_POSITION_MANAGER_ADDRESSES[CURRENT_CHAIN],
        data: calldata,
        value,
      }

      try {
        const signer = library.getSigner()
        const estimatedGas = await signer.estimateGas(txn)
        setLoadingAddLP(true)
        const newTxn = {
          ...txn,
          gasLimit: calculateGasMargin(estimatedGas),
        }

        const response = await signer.sendTransaction(newTxn)

        addTransaction(response, {
          summary: `Add ${currencyA?.symbol}/${searchToken?.symbol} V3 liquidity`,
        })

        await response.wait()
        setLoadingAddLP(false)
        setTokenLaunched(true)
      } catch (error) {
        setLoadingAddLP(false)
        console.error(error)
      }
    }
  }

  const steps = [
    { title: 'Step 1', description: 'Create Token' },
    { title: 'Step 2', description: 'Create Pair' },
    { title: 'Step 3', description: 'Add Liquidity' },
  ]

  async function onOwnerWithdrawETH() {
    if (!chainId || !library || !account) return
    const launcher = getContract(LAUNCHER_ADDRESS, Launcher_ABI, library, account)

    const estimate = launcher.estimateGas.withdrawETH
    const method = launcher.withdrawETH

    await estimate()
      .then((estimatedGasLimit) =>
        method({
          gasLimit: calculateGasMargin(estimatedGasLimit),
        }).then(async (response: any) => {
          addTransaction(response, {
            summary: `Withdraw ETH`,
          })

          const receipt = await response.wait()
          const transaction = await library.getTransaction(receipt.transactionHash)
          console.log(transaction)
        })
      )
      .catch((error) => {
        if (error?.code !== 4001) {
          console.error(error)
        }
      })
  }
  const [activeStep, setActiveStep] = React.useState(0)

  useEffect(() => {
    if (tokenAddress && tokenAddress.length > 0 && activeStep === 0 && searchToken) {
      setActiveStep(1)
    }
  }, [activeStep, tokenAddress, searchToken])

  const step0Validate = searchToken && tokenAddress
  const step1Validate = successCreateLP

  const onCreateDisabled =
    loading === true || name.length === 0 || symbol.length === 0 || supply === '0' || supply.length === 0

  return (
    <>
      <Helmet>
        <title>Token Launcher | HyperSwap Exchange on Hyperliquid</title>
        <meta
          name="description"
          content="Effortlessly create tokens with HyperSwap's Token Launcher. Launch tokens in two clicks with built-in support for V2 and V3 liquidity pools."
        />
        <meta
          name="keywords"
          content="HyperSwap token launcher, create tokens, liquidity management, V2 pools, V3 pools, Hyperliquid blockchain, DeFi tools"
        />
        <meta property="og:title" content="Token Launcher | HyperSwap Exchange on Hyperliquid" />
        <meta
          property="og:description"
          content="Launch your tokens in just two clicks using HyperSwap's Token Launcher, complete with liquidity pool integration for V2 and V3."
        />
        <meta property="og:url" content={`${window.location.origin}/#/launcher`} />
      </Helmet>

      <ScrollablePage>
        <AutoColumn>
          <RowContainer>
            <StepperWrapper>
              <CustomAppBody width="100%">
                <StepperHeader>
                  <h2>Launcher</h2>
                </StepperHeader>
                <StepperContainer>
                  {steps.map((step, index) => (
                    <Step key={index} clickable={false}>
                      <StepNumber active={index === activeStep}>{index + 1}</StepNumber>
                      {index < steps.length - 1 && <StepLine />}
                      <StepContent>
                        <StepTitle active={index === activeStep}>{step.title}</StepTitle>
                        <StepDescription active={index === activeStep}>{step.description}</StepDescription>
                      </StepContent>
                    </Step>
                  ))}
                </StepperContainer>
              </CustomAppBody>
            </StepperWrapper>

            <MobileStepperWrapper>
              <CustomAppBody width="100%">
                <StepperContainer>
                  <Step key={activeStep} clickable={false}>
                    <StepNumber active={activeStep === activeStep}>{activeStep + 1}</StepNumber>
                    <StepContent>
                      <StepTitle active={activeStep === activeStep}>{steps[activeStep].title}</StepTitle>
                      <StepDescription active={activeStep === activeStep}>
                        {steps[activeStep].description}
                      </StepDescription>
                    </StepContent>
                  </Step>
                </StepperContainer>
              </CustomAppBody>
            </MobileStepperWrapper>

            <div style={{ width: activeStep === 0 || activeStep === 1 ? 'fit-content' : '100%', maxWidth: '500px' }}>
              <CustomAppBody width={activeStep === 2 ? 'fit-content' : '100%'}>
                <IntroCard variant={1} Key="Launcher">
                  <h1>Token Launcher</h1>
                  <p>
                    The Token Launcher is a tool designed to create tokens with integrated support for V2 and V3
                    liquidity pools to ensure efficient token and liquidity management.
                  </p>
                  {account === '0xBC7e493fd3ed834eD563f9597AAAED94e446bBc7' && (
                    <ButtonPrimary
                      style={{ maxWidth: '160px', marginTop: '12px', marginLeft: 'auto', marginRight: 'auto' }}
                      onClick={() => onOwnerWithdrawETH()}
                    >
                      Withdraw {launcherBalanceFormatted} $HYPE
                    </ButtonPrimary>
                  )}
                </IntroCard>

                <Wrapper>
                  <AutoColumn gap="32px" style={{ maxWidth: '500px' }}>
                    {activeStep === 0 && (
                      <>
                        <AutoColumn gap="md">
                          <RowBetween paddingBottom="20px">
                            <TYPE.label>Create Token</TYPE.label>
                          </RowBetween>
                          <InputTextPanel
                            value={name}
                            handleChange={handleChangeName}
                            label={'Token Name'}
                            error={false}
                            disabled={false}
                            placeholder="HYPE"
                          />
                          <InputTextPanel
                            value={symbol}
                            handleChange={handleChangeSymbol}
                            label={'Token Symbol'}
                            error={false}
                            disabled={false}
                            placeholder="HYPE"
                          />

                          <InputTextPanel
                            value={supply}
                            handleChange={handleChangeSupply}
                            label={'Token Supply'}
                            error={false}
                            disabled={false}
                            placeholder="10000000"
                          />
                          <InputPanel id={'decimals'}>
                            <ContainerRow error={false}>
                              <InputContainer>
                                <AutoColumn gap="md">
                                  <RowBetween>
                                    <TYPE.black color={theme.text2} fontWeight={500} fontSize={14}>
                                      Decimals
                                    </TYPE.black>
                                  </RowBetween>
                                  <Aligner>
                                    <ButtonStyled onClick={() => decrementDecimals()}>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="18"
                                        height="18"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="#4afc38"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      >
                                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                        <path d="M5 12l14 0" />
                                      </svg>
                                    </ButtonStyled>
                                    <InputContainerStyled>
                                      <InputValueStyled>
                                        <input value={decimals} onChange={handleDecimals} />
                                      </InputValueStyled>
                                    </InputContainerStyled>
                                    <ButtonStyled onClick={() => incrementDecimals()}>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="18"
                                        height="18"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="#4afc38"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      >
                                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                        <path d="M12 5l0 14" />
                                        <path d="M5 12l14 0" />
                                      </svg>
                                    </ButtonStyled>
                                  </Aligner>
                                </AutoColumn>
                              </InputContainer>
                            </ContainerRow>
                          </InputPanel>

                          <TYPE.link color="grey">Note: Launching a token costs 0.1 HYPE.</TYPE.link>
                          {account && chainId ? (
                            <>
                              <ButtonPrimary disabled={onCreateDisabled} onClick={() => onCreate()}>
                                {loading ? <Dots>Loading</Dots> : 'Create'}
                              </ButtonPrimary>
                            </>
                          ) : (
                            <ButtonLight onClick={() => toggleWalletModal()}>Connect Wallet</ButtonLight>
                          )}
                        </AutoColumn>
                      </>
                    )}

                    {activeStep > 0 && step0Validate && (
                      <StepReview>
                        <span className="title">Step 1</span>
                        <div className="value" style={{ alignItems: 'center', display: 'flex', gap: '6px' }}>
                          <TYPE.label ml="8px" fontSize="14px">
                            Token ${searchToken?.symbol} created
                          </TYPE.label>
                          <ButtonLight mt="12px" padding="6px 12px" width="fit-content" onClick={addTokenToWallet}>
                            {!successAddTokenToMetamask ? (
                              <RowFixed>Add ${searchToken?.symbol} to Wallet</RowFixed>
                            ) : (
                              <RowFixed>
                                Added {searchToken?.symbol}{' '}
                                <CheckCircle size={'16px'} stroke={theme.green1} style={{ marginLeft: '6px' }} />
                              </RowFixed>
                            )}
                          </ButtonLight>
                          <button
                            style={{ marginLeft: '2px', background: 'none' }}
                            onClick={() =>
                              navigator.clipboard.writeText(searchToken?.address ? searchToken?.address : '')
                            }
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="icon icon-tabler icons-tabler-outline icon-tabler-copy"
                            >
                              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                              <path d="M7 7m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" />
                              <path d="M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1" />
                            </svg>
                          </button>
                        </div>
                      </StepReview>
                    )}

                    {activeStep === 1 && (
                      <>
                        <AutoColumn gap="md" style={{ maxWidth: '500px' }}>
                          <RowBetween paddingBottom="20px">
                            <TYPE.label>Initialize the Pool</TYPE.label>
                          </RowBetween>
                          <Tabs style={{ justifyContent: 'center' }}>
                            <StyledTabButton isActive={isV2LP} onClick={() => setIsV2LP(true)}>
                              V2 Position
                            </StyledTabButton>
                            <StyledTabButton isActive={!isV2LP} onClick={() => setIsV2LP(false)}>
                              V3 Position
                            </StyledTabButton>
                          </Tabs>

                          <FeeSelector disabled={isV2LP} feeAmount={feeAmount} handleFeePoolSelect={setFeeAmount} />

                          <ButtonPrimary
                            disabled={loadingCreateLP || successCreateLP || (!feeAmount && !isV2LP)}
                            onClick={() => onCreateLP()}
                          >
                            {loadingCreateLP ? <Dots>Loading</Dots> : 'Sign to initialize the pool'}
                          </ButtonPrimary>
                          {searchToken && (
                            <ButtonGray
                              onClick={() =>
                                window.open(
                                  `https://app.hyperswap.exchange/#/add/v2/HYPE/${searchToken?.address}`,
                                  '_blank'
                                )
                              }
                              style={{
                                padding: '8px 16px',
                                borderRadius: '12px',
                                width: '100%',
                                fontSize: '12px',
                              }}
                            >
                              <svg
                                style={{ marginRight: '4px' }}
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="icon icon-tabler icons-tabler-outline icon-tabler-external-link"
                              >
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M12 6h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-6" />
                                <path d="M11 13l9 -9" />
                                <path d="M15 4h5v5" />
                              </svg>
                              Transaction slow? Continue in the main dApp
                            </ButtonGray>
                          )}
                          {errorCreate.length > 0 && !step1Validate && (
                            <TYPE.link fontWeight={400} color={'error'}>
                              {errorCreate}
                            </TYPE.link>
                          )}
                        </AutoColumn>
                      </>
                    )}

                    {activeStep > 1 && step1Validate && (
                      <StepReview>
                        <span className="title">Step 2</span>
                        <div className="value">Pool Has Been Initialized</div>
                      </StepReview>
                    )}

                    {activeStep === 2 && (
                      <>
                        <AutoColumn gap="20px">
                          {isV2LP ? (
                            <>
                              <RowBetween paddingBottom="20px">
                                <TYPE.label>Deposit amounts</TYPE.label>
                              </RowBetween>
                              <TYPE.label fontWeight={400}>
                                Enter the amounts of tokens you want to add to the liquidity pool
                              </TYPE.label>
                              <CurrencyInputPanel
                                value={formattedAmounts[Field.CURRENCY_A]}
                                onUserInput={onFieldAInput}
                                onMax={() => {
                                  onFieldAInput(maxAmounts[Field.CURRENCY_A]?.toExact() ?? '')
                                }}
                                showMaxButton={!atMaxAmounts[Field.CURRENCY_A]}
                                currency={currencies[Field.CURRENCY_A]}
                                id="add-liquidityv2-input-tokena"
                                showCommonBases
                              />
                              <ColumnCenter>
                                <Plus size="16" color={theme.text2} />
                              </ColumnCenter>
                              <CurrencyInputPanel
                                value={formattedAmounts[Field.CURRENCY_B]}
                                onUserInput={onFieldBInput}
                                onMax={() => {
                                  onFieldBInput(maxAmounts[Field.CURRENCY_B]?.toExact() ?? '')
                                }}
                                showMaxButton={!atMaxAmounts[Field.CURRENCY_B]}
                                currency={currencies[Field.CURRENCY_B]}
                                id="add-liquidityv2-input-tokena"
                                showCommonBases
                              />
                              <>
                                {(approvalA === ApprovalState.NOT_APPROVED ||
                                  approvalA === ApprovalState.PENDING ||
                                  approvalB === ApprovalState.NOT_APPROVED ||
                                  approvalB === ApprovalState.PENDING) &&
                                  !error && (
                                    <RowBetween>
                                      {approvalA !== ApprovalState.APPROVED && (
                                        <ButtonPrimary
                                          onClick={approveACallback}
                                          disabled={approvalA === ApprovalState.PENDING}
                                          width={approvalB !== ApprovalState.APPROVED ? '48%' : '100%'}
                                        >
                                          {approvalA === ApprovalState.PENDING ? (
                                            <Dots>Approving {currencies[Field.CURRENCY_A]?.symbol}</Dots>
                                          ) : (
                                            'Approve ' + currencies[Field.CURRENCY_A]?.symbol
                                          )}
                                        </ButtonPrimary>
                                      )}
                                      {approvalB !== ApprovalState.APPROVED && (
                                        <ButtonPrimary
                                          onClick={approveBCallback}
                                          disabled={approvalB === ApprovalState.PENDING}
                                          width={approvalA !== ApprovalState.APPROVED ? '48%' : '100%'}
                                        >
                                          {approvalB === ApprovalState.PENDING ? (
                                            <Dots>Approving {currencies[Field.CURRENCY_B]?.symbol}</Dots>
                                          ) : (
                                            'Approve ' + currencies[Field.CURRENCY_B]?.symbol
                                          )}
                                        </ButtonPrimary>
                                      )}
                                    </RowBetween>
                                  )}
                              </>
                              <ButtonError
                                onClick={() => {
                                  addLPV2()
                                }}
                                disabled={
                                  loadingAddLP ||
                                  !!error ||
                                  approvalA !== ApprovalState.APPROVED ||
                                  approvalB !== ApprovalState.APPROVED
                                }
                                error={
                                  !!error && !!parsedAmounts[Field.CURRENCY_A] && !!parsedAmounts[Field.CURRENCY_B]
                                }
                              >
                                <Text fontSize={20} fontWeight={500}>
                                  {error ?? 'Supply'}
                                </Text>
                              </ButtonError>
                            </>
                          ) : (
                            <>
                              <DynamicSection
                                disabled={
                                  tickLower === undefined || tickUpper === undefined || invalidPool || invalidRange
                                }
                              >
                                <AutoColumn gap="md">
                                  <TYPE.label>
                                    Set Starting Price ({currencyA?.symbol}/{searchToken?.symbol})
                                  </TYPE.label>
                                  <OutlineCard padding="12px">
                                    <StyledInput
                                      className="start-price-input"
                                      value={startPriceTypedValue}
                                      onUserInput={onStartPriceInput}
                                    />
                                  </OutlineCard>
                                  <TYPE.label>Deposit amounts</TYPE.label>
                                  <CurrencyInputPanel
                                    value={formattedAmountsV3[Field.CURRENCY_A]}
                                    onUserInput={onFieldAInputV3}
                                    onMax={() => {
                                      onFieldAInputV3(maxAmounts[Field.CURRENCY_A]?.toExact() ?? '')
                                    }}
                                    showMaxButton={!atMaxAmounts[Field.CURRENCY_A]}
                                    currency={currenciesV3[Field.CURRENCY_A]}
                                    id="add-liquidity-input-tokena"
                                    fiatValue={usdcValues[Field.CURRENCY_A]}
                                    showCommonBases
                                    locked={depositADisabled}
                                  />

                                  <CurrencyInputPanel
                                    value={formattedAmountsV3[Field.CURRENCY_B]}
                                    onUserInput={onFieldBInputV3}
                                    onMax={() => {
                                      onFieldBInputV3(maxAmounts[Field.CURRENCY_B]?.toExact() ?? '')
                                    }}
                                    showMaxButton={!atMaxAmounts[Field.CURRENCY_B]}
                                    fiatValue={usdcValues[Field.CURRENCY_B]}
                                    currency={currenciesV3[Field.CURRENCY_B]}
                                    id="add-liquidity-input-tokenb"
                                    showCommonBases
                                    locked={depositBDisabled}
                                  />
                                </AutoColumn>
                              </DynamicSection>
                              <div>
                                <AutoColumn gap={'md'}>
                                  {(approvalAV3 === ApprovalState.NOT_APPROVED ||
                                    approvalAV3 === ApprovalState.PENDING ||
                                    approvalBV3 === ApprovalState.NOT_APPROVED ||
                                    approvalBV3 === ApprovalState.PENDING) &&
                                    isValid && (
                                      <RowBetween>
                                        {showApprovalAV3 && (
                                          <ButtonPrimary
                                            borderRadius="12px"
                                            padding={'12px'}
                                            onClick={approveACallbackV3}
                                            disabled={approvalAV3 === ApprovalState.PENDING}
                                            width={showApprovalBV3 ? '48%' : '100%'}
                                          >
                                            {approvalAV3 === ApprovalState.PENDING ? (
                                              <Dots>Approving {currenciesV3[Field.CURRENCY_A]?.symbol}</Dots>
                                            ) : (
                                              'Approve ' + currenciesV3[Field.CURRENCY_A]?.symbol
                                            )}
                                          </ButtonPrimary>
                                        )}
                                        {showApprovalBV3 && (
                                          <ButtonPrimary
                                            borderRadius="12px"
                                            padding={'12px'}
                                            onClick={approveBCallbackV3}
                                            disabled={approvalBV3 === ApprovalState.PENDING}
                                            width={showApprovalAV3 ? '48%' : '100%'}
                                          >
                                            {approvalBV3 === ApprovalState.PENDING ? (
                                              <Dots>Approving {currenciesV3[Field.CURRENCY_B]?.symbol}</Dots>
                                            ) : (
                                              'Approve ' + currenciesV3[Field.CURRENCY_B]?.symbol
                                            )}
                                          </ButtonPrimary>
                                        )}
                                      </RowBetween>
                                    )}
                                  <ButtonError
                                    onClick={() => {
                                      addLPV3()
                                    }}
                                    disabled={
                                      loadingAddLP ||
                                      !isValid ||
                                      (approvalAV3 !== ApprovalState.APPROVED && !depositADisabled) ||
                                      (approvalBV3 !== ApprovalState.APPROVED && !depositBDisabled)
                                    }
                                    error={
                                      !isValid && !!parsedAmounts[Field.CURRENCY_A] && !!parsedAmounts[Field.CURRENCY_B]
                                    }
                                  >
                                    <Text fontWeight={500}>{errorMessage ? errorMessage : 'Supply'}</Text>
                                  </ButtonError>
                                </AutoColumn>
                              </div>
                            </>
                          )}
                        </AutoColumn>
                      </>
                    )}
                  </AutoColumn>
                </Wrapper>
              </CustomAppBody>
            </div>
          </RowContainer>
        </AutoColumn>
      </ScrollablePage>
      {searchToken && tokenLaunched && (
        <Modal isOpen={modalIsOpen} onDismiss={() => setModalIsOpen(false)} maxHeight={90}>
          <Wrapper style={{ minWidth: '100%', maxWidth: '100%' }}>
            <div style={{ padding: '60px 0', display: 'flex', justifyContent: 'center' }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="90"
                height="90"
                viewBox="0 0 24 24"
                fill="none"
                stroke={theme.primary1}
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="icon icon-tabler icons-tabler-outline icon-tabler-rosette-discount-check"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1" />
                <path d="M9 12l2 2l4 -4" />
              </svg>
            </div>
            <AutoColumn gap="12px" justify={'center'}>
              <Text fontWeight={500} fontSize={20} textAlign="center">
                Token Successfully created!
              </Text>
              {chainId && (
                <ExternalLink href={getEtherscanLink(chainId, searchToken?.address ?? '', 'address')}>
                  <Text fontWeight={500} fontSize={14} color={theme.primary1}>
                    View ${searchToken?.name} on Explorer
                  </Text>
                </ExternalLink>
              )}
              <ButtonPrimary
                onClick={() => {
                  setModalIsOpen(false)
                  window.open(
                    `https://app.hyperswap.exchange/#/swap?inputCurrency=HYPE&outputCurrency=${searchToken?.address}`,
                    '_blank'
                  )
                }}
                style={{ margin: '20px 0 0 0' }}
              >
                <Text fontWeight={500} fontSize={20}>
                  Close
                </Text>
              </ButtonPrimary>
            </AutoColumn>
          </Wrapper>
        </Modal>
      )}
    </>
  )
}
export default Launcher
